import { render } from "./AnalyzeAspirations.vue?vue&type=template&id=27886555&scoped=true"
import script from "./AnalyzeAspirations.vue?vue&type=script&lang=js"
export * from "./AnalyzeAspirations.vue?vue&type=script&lang=js"

import "./AnalyzeAspirations.vue?vue&type=style&index=0&id=27886555&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27886555"]])

export default __exports__